<template lang="pug">
    include RestrictedAreaBlock.pug
</template>

<script>
import PubSub from "pubsub-js";

export default {
    name: 'RestrictedAreaBlock',
    methods: {
        toggleLogin() {
            PubSub.publish("login.show");
        }
    }
}

</script>

<style scoped lang="scss">
@import "./../../variables";
@import "RestrictedAreaBlock";
</style>



// WEBPACK FOOTER //
// src/components/restricted_area_block/RestrictedAreaBlock.vue